<template>
  <div class="info-tooltip">
    <el-tooltip
      popper-class="common-info-tooltip"
      effect="light"
      :placement="placement"
    >
      <div slot="content" class="common-info-tooltip__content">
        {{ content }}
      </div>
      <div class="icon"></div>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      required: true
    },
    placement: {
      type: String,
      default: "bottom"
    }
  }
};
</script>

<style lang="less" scoped>
.info-tooltip {
  display: flex;
  height: 100%;
  align-items: center;
  .icon {
    width: 18px;
    height: 100%;
    background-image: url("~@/assets/images/icon_info.png");
    background-size: 100%;
    background-position: center center;
    background-repeat: no-repeat;
    cursor: pointer;
  }
}
</style>
